
export default {
  name: "ExtraMenu",

  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    countItemsLine: function () {
      if (window.innerWidth < 640) {
        return 1
      }
      if (window.innerWidth < 1024) {
        return 2
      }
      return 4
    },
    itemList: function () {
      let items = this.items.filter((t) => !t.isHidden);
      const countSections = this.countItemsLine;


      const section = Array(countSections).fill([]).map((section, indexSection) => {
        const indexElements = items.map((t, index) => indexSection + index * countSections);
        const elements = [...items].filter((t, indexItem) => indexElements.includes(indexItem));

        return elements
      });

      return section
    }
  },

  components: {
    ExtraMenuItem: () => import("./_ExtraMenuItem")
  }
}
